import { NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { hasCapability } from "@/lib/roles";

const items = [
  ["/app/fees/overview", "Overview", ["finance.account.view"]],
  ["/app/fees/structures", "Fee Structures", ["finance.fee_structure.manage"]],
  ["/app/fees/accounts", "Student Accounts", ["finance.account.view"]],
  ["/app/fees", "Payments", ["finance.account.view", "finance.payment.record", "finance.payment.allocate"]],
  ["/app/fees/class-summary", "Payment Status", ["finance.payment_status.view_class"]],
  ["/app/fees/scholarships", "Scholarships", ["finance.scholarship.manage"]],
  ["/app/fees/operations", "Refunds / Reversals", [
    "finance.reversal.request",
    "finance.reversal.finalize",
    "finance.refund.request",
    "finance.refund.finalize",
    "finance.audit.view",
  ]],
  ["/app/fees/reconciliation", "Reconciliation", ["finance.reconcile"]],
];

const FinanceNav = () => {
  const { user } = useAuth();

  return (
    <nav className="flex gap-1 overflow-x-auto border-b border-[#E2E8F0] mb-6 pb-1" aria-label="Finance">
      {items
        .filter(([, , capabilities]) =>
          capabilities.some((capability) => hasCapability(user, capability))
        )
        .map(([to, label]) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/app/fees"}
            className={({ isActive }) =>
              `shrink-0 px-3 py-2 rounded-t-lg text-sm ${
                isActive
                  ? "bg-[#1B2C5A] text-white"
                  : "text-[#475569] hover:bg-[#9DCD3F]/10"
              }`
            }
          >
            {label}
          </NavLink>
        ))}
    </nav>
  );
};

export default FinanceNav;
